export const projectConfig = {
    // baseURL: 'http://192.168.2.75:8201/',
    baseURL: 'http://81.71.32.170:8201',
    // baseURL: 'http://www.angstrong.com:8201/',
    projectName: '深圳市安思疆科技有限公司',
}